import { Menu } from '@headlessui/react';
import { FC, PropsWithChildren } from 'react';
import { toClassNames } from '@/utils';

const AvatarMenuItem: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
  return (
    <Menu.Item
      as="div"
      className={toClassNames('m-1 cursor-pointer rounded-md px-2 py-1 ui-active:bg-primary-50', className)}
    >
      {children}
    </Menu.Item>
  );
};

export default AvatarMenuItem;
